import React from "react";
import ProductScreen from "../../components/ProductScreen";

export default function Discovery() {
  return (
    <ProductScreen
      heroImageSrc="/product-heroes/discovery.png"
      eyebrow="Products / Discovery"
      title="Discovery"
      accent="#f46a12"
      description="Find leads, buyers, suppliers and opportunities."
      bullets={[
        "Search, signal, and analytics tools for market discovery.",
        "Surface relevant opportunities and prioritize action.",
        "Help teams move from finding to engaging faster.",
      ]}
      features={[
        { title: "Search", text: "Locate businesses, buyers, and opportunities with clarity." },
        { title: "Signals", text: "Track activity and changes that matter to your pipeline." },
        { title: "Analytics", text: "Turn discovery activity into actionable insights." },
      ]}
      ctaLabel="Explore Discovery"
      summaryKicker="Discovery Layer"
      summaryTitle="Turn market search into a cleaner, more actionable pipeline."
      summaryText="Discovery is built for surfacing verified opportunities and moving them into a system the team can actually work from."
    />
  );
}
